import {createSlice, current} from "@reduxjs/toolkit";
import { produce } from "immer";

export const loadingSlice = createSlice({
    name: 'loading',
    initialState: {
        value: false
    },
    reducers: {
        toggleLoading: (state, action) => {
            return produce(current(state), draft => {
                draft.value = !state.value
            })
        },
        showLoader: (state, action) => {
            return produce(current(state), draft => {
                draft.value = true
            })
        },
        hideLoader: (state, action) => {
            return produce(current(state), draft => {
                draft.value = false
            })
        },
    }
})

export const { toggleLoading, showLoader, hideLoader } = loadingSlice.actions

export default loadingSlice.reducer
